import { SVGProps } from "react";

const PillBoxCloseIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8.121}
    height={8.121}
    {...props}
  >
    <g
      fill="none"
      stroke={props.stroke ? props.stroke : "#97a0af"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
    >
      <path data-name="Line 847" d="m7.061 1.061-6 6" />
      <path data-name="Line 846" d="m1.061 1.061 6 6" />
    </g>
  </svg>
);

export default PillBoxCloseIcon
